var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBalloon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 91,
    viewBox: "0 0 120 91"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "Balloon_svg__a",
    d: "M0 0h120v91H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Balloon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Balloon_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    mask: "url(#Balloon_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E74536",
    d: "M52.708 90.957a3.634 3.634 0 117.27 0h-7.27z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.264,
    cy: 29.264,
    r: 27.264,
    fill: "#2175D9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2175D9",
    d: "M23.628 29.16a3.635 3.635 0 117.271.001h-7.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E74536",
    d: "M61.802 33.343a27.436 27.436 0 00-5.459-.547c-15.057 0-27.264 12.207-27.264 27.264 0 15.057 12.207 27.263 27.264 27.263 13.867 0 25.316-10.353 27.04-23.754-12.428-4.495-21.35-16.302-21.581-30.226z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.511,
    cy: 32.796,
    r: 32.715,
    fill: "#FFB511"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB511",
    d: "M90.877 69.146a3.635 3.635 0 013.636-3.635 3.634 3.634 0 013.635 3.635h-7.27z"
  }))))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTIwIiBoZWlnaHQ9IjkxIiB2aWV3Qm94PSIwIDAgMTIwIDkxIj4KICAgIDxkZWZzPgogICAgICAgIDxwYXRoIGlkPSJzaHN5ZTQ2YndhIiBkPSJNMCAwSDEyMFY5MUgweiIvPgogICAgPC9kZWZzPgogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8Zz4KICAgICAgICAgICAgPG1hc2sgaWQ9Impqb2N3enZiZmIiIGZpbGw9IiNmZmYiPgogICAgICAgICAgICAgICAgPHVzZSB4bGluazpocmVmPSIjc2hzeWU0NmJ3YSIvPgogICAgICAgICAgICA8L21hc2s+CiAgICAgICAgICAgIDxnIGZpbGwtcnVsZT0ibm9uemVybyIgbWFzaz0idXJsKCNqam9jd3p2YmZiKSI+CiAgICAgICAgICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtOCkiPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGZpbGw9IiNFNzQ1MzYiIGQ9Ik01Mi43MDggOTAuOTU3YzAtMi4wMDkgMS42MjYtMy42MzYgMy42MzUtMy42MzYgMi4wMDggMCAzLjYzNSAxLjYyNyAzLjYzNSAzLjYzNmgtNy4yN3oiLz4KICAgICAgICAgICAgICAgICAgICA8Y2lyY2xlIGN4PSIyNy4yNjQiIGN5PSIyOS4yNjQiIHI9IjI3LjI2NCIgZmlsbD0iIzIxNzVEOSIvPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGZpbGw9IiMyMTc1RDkiIGQ9Ik0yMy42MjggMjkuMTZjMC0yLjAwOCAxLjYyNy0zLjYzNSAzLjYzNi0zLjYzNSAyLjAwOCAwIDMuNjM1IDEuNjI3IDMuNjM1IDMuNjM2aC03LjI3eiIvPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGZpbGw9IiNFNzQ1MzYiIGQ9Ik02MS44MDIgMzMuMzQzYy0xLjc2NS0uMzU4LTMuNTktLjU0Ny01LjQ1OS0uNTQ3LTE1LjA1NyAwLTI3LjI2NCAxMi4yMDctMjcuMjY0IDI3LjI2NCAwIDE1LjA1NyAxMi4yMDcgMjcuMjYzIDI3LjI2NCAyNy4yNjMgMTMuODY3IDAgMjUuMzE2LTEwLjM1MyAyNy4wNC0yMy43NTQtMTIuNDI4LTQuNDk1LTIxLjM1LTE2LjMwMi0yMS41ODEtMzAuMjI2eiIvPgogICAgICAgICAgICAgICAgICAgIDxjaXJjbGUgY3g9Ijk0LjUxMSIgY3k9IjMyLjc5NiIgcj0iMzIuNzE1IiBmaWxsPSIjRkZCNTExIi8+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iI0ZGQjUxMSIgZD0iTTkwLjg3NyA2OS4xNDZjMC0yLjAwOCAxLjYyNy0zLjYzNSAzLjYzNi0zLjYzNSAyLjAwOCAwIDMuNjM1IDEuNjI3IDMuNjM1IDMuNjM1aC03LjI3eiIvPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgBalloon as ReactComponent };